"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieStorageReducerBase = void 0;
var tslib_1 = require("tslib");
var cookieConstants_1 = require("./../../constants/cookieConstants");
var cookieStore_1 = require("./../../utilities/cookieStore");
var removeUndefined_1 = require("./../../utilities/removeUndefined");
var actions_1 = require("../../constants/actions");
var cookieStorageReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === actions_1.GET_COOKIE_STORAGE_SUCCESS) {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.values);
    }
    if (action.type === actions_1.SET_COOKIE_STORAGE) {
        var removedUndefined = (0, removeUndefined_1.removeUndefined)(action.values);
        var mergedWithState = tslib_1.__assign(tslib_1.__assign({}, state), removedUndefined);
        var newState = action.replace ? removedUndefined : mergedWithState;
        cookieStore_1.cookieStore.set(cookieConstants_1.PRIMARY_STORAGE_KEY_COOKIE, newState);
        return newState;
    }
    return state || null;
};
exports.cookieStorageReducerBase = cookieStorageReducerBase;
